import { BrowserModule } from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { DragScrollModule } from 'ngx-drag-scroll';

import { AngularMyDatePickerModule } from 'angular-mydatepicker';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { SliderModule } from 'primeng/slider';
import {TabViewModule} from 'primeng/tabview';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { TextMaskModule } from 'angular2-text-mask';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import { OrderModule } from 'ngx-order-pipe';
import { SocketIoModule } from 'ngx-socket-io';
import { SnotifyModule, SnotifyService, ToastDefaults } from 'ng-snotify';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { AngularDraggableModule } from 'angular2-draggable';

import { NgxPaginationModule } from 'ngx-pagination';
import { IndexComponent } from './pages/index/index.component';
import { MainNewComponent } from './pages/main-new/main-new.component';
import { NgbModule, NgbTimepickerModule, NgbProgressbarModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskModule, IConfig } from 'ngx-mask';
export const options: Partial<null|IConfig> | (() => Partial<IConfig>) = null;
import { NgxEchartsModule } from 'ngx-echarts';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

registerLocaleData(localeFr);
import { MatTooltipModule } from '@angular/material/tooltip';
import { MenuModule } from 'primeng/menu';
import {MenubarModule} from 'primeng/menubar';
import { MatMenuModule} from '@angular/material/menu';
import {SharedModule} from "./shared/shared.module";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {httpLoaderFactory} from "./translate";
import {LoginComponent} from "./routes/auth/login/login.component";
import {GlobalErrorHandler} from "./global-error-handler";

@NgModule({
  declarations: [
    AppComponent,

    IndexComponent,
    MainNewComponent,
    LoginComponent,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    AppRoutingModule,
    AngularMyDatePickerModule,
    NguiAutoCompleteModule,
    MatDialogModule,
    MatSelectModule,
    MatTabsModule,
    MatTooltipModule,
    HttpClientModule,
    MatNativeDateModule,
    MatStepperModule,
    BrowserAnimationsModule,
    OrderModule,
    TextMaskModule,
    SocketIoModule,//.forRoot(config),
    DragScrollModule,
    SnotifyModule,
    PopoverModule.forRoot(),
    AngularDraggableModule,
    NgxPaginationModule,
    NgbTimepickerModule,
    NgbProgressbarModule,
    NgbTooltipModule,
    NgbModule,
    NgSelectModule,
    NgxMaskModule.forRoot(),
    NgxEchartsModule,
    TooltipModule.forRoot(),
    SliderModule,
    TabViewModule,
    MenuModule,
    MenubarModule,
    MatMenuModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient]
      },
      isolate: true
    }),
  ],
  providers: [
    DatePipe,
    {
      provide: 'SnotifyToastConfig',
      useValue: ToastDefaults
    },
    SnotifyService,
    {
      provide: LOCALE_ID,
      useValue: 'fr-FR'
    },
    {provide: ErrorHandler, useClass: GlobalErrorHandler}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
